import React from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { Field } from "./Field";

const useStyles = makeStyles(theme => ({
  formItem: {
    marginBottom: theme.spacing(3)
  },
  inline: {
    display: "flex",
    alignItems: "center",

    "& $label": {
      marginBottom: 0
    }
  },
  label: {
    display: "inline-flex",
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  labelBold: {
    fontWeight: "bold"
  },
  requiredBefore: {
    "&:before": {
      content: "'*'",
      color: theme.palette.secondary.main,
      marginRight: 5,
      marginLeft: -5,
      fontSize: 16,
      display: "inline-block",
      height: 8,
      lineHeight: 1,
      marginTop: 4
    }
  },
  requiredAfter: {
    "&:after": {
      content: "'*'",
      color: theme.palette.secondary.main,
      marginLeft: 5,
      fontSize: 16,
      display: "inline-block",
      height: 8,
      lineHeight: 1,
      marginTop: 4
    }
  },
  content: {
    flex: 1
  },
  errMsg: {
    marginTop: theme.spacing(1)
  }
}));

const FormItem = ({
  label,
  labelBold,
  labelWidth,
  required,
  requireMarkType = "after",
  colon = true,
  disabled,
  noStyle,
  row,
  className,
  style,
  children,
  name,
  innerRef,
  validate,
  rules,
  shouldUpdate,
  dependencies
}) => {
  const classes = useStyles();

  const content = name ? (
    <Field
      name={name}
      disabled={disabled}
      innerRef={innerRef}
      validate={validate}
      rules={rules}
      shouldUpdate={shouldUpdate}
      dependencies={dependencies}
    >
      {children}
    </Field>
  ) : (
    children
  );

  if (noStyle) {
    return content;
  }

  return (
    <div
      className={clsx(
        "ui-form-item",
        classes.formItem,
        !row && classes.inline,
        className
      )}
      style={style}
    >
      {label && (
        <div
          className={clsx(
            classes.label,
            required && classes.required,
            labelBold && classes.labelBold,
            required &&
              (requireMarkType === "before"
                ? classes.requiredBefore
                : classes.requiredAfter)
          )}
          style={{ width: labelWidth }}
        >
          {label}
          {colon ? ":" : ""}
        </div>
      )}
      <div className={classes.content}>{content}</div>
    </div>
  );
};

export default FormItem;
